import {
  APP_ENVS,
  currentAppEnvironment,
} from '@savgroup-front-common/constants';

export const LOGTO_ENABLED_HOSTNAME = [
  'dev-app.revers.io',
  'dev2-app.revers.io',
  'demo-app.revers.io',
  'demo-control.revers.io',
  'demo2-app.revers.io',
  'app2.revers.io',
  'app.revers.io',
  'app.dev.revers.io',
  'app.demo.revers.io',

  'marwen-localhost.revers.io',

  'dev-app-carrefour.revers.io',
  'demo-app-carrefour.revers.io',
  'app-carrefour.revers.io',

  'demo-app-auchan.revers.io',
  'app-auchan.revers.io',

  'app-cooperative-u.revers.io',
  'demo-app-cooperative-u.revers.io',

  'demo-app-maisonsdumonde.revers.io',
  'app-maisonsdumonde.revers.io',

  'dev-field-service-app.revers.io',
  'demo-field-service-app.revers.io',
  'field-service.revers-app.io',

  'demo-app-cultura.revers.io',
];

export const isLogtoEnabled = () => {
  if (
    LOGTO_ENABLED_HOSTNAME.includes(
      typeof window !== 'undefined' ? window.location.hostname : '',
    )
  ) {
    return true;
  }

  if (
    window?.location?.hostname.includes('.preview-front.dev-app.revers.io') ||
    window?.location?.hostname.includes(
      '.preview-front.dev-field-service-app.revers.io',
    ) ||
    window?.location?.hostname.includes('.preview.dev-app.revers.io') ||
    window?.location?.hostname.includes(
      '.preview.dev-field-service-app.revers.io',
    )
  ) {
    return true;
  }

  if (window?.location?.hostname === 'localhost') {
    if (import.meta.env.VITE_BASE_URL) {
      return true;
    }

    return window.location.port === '3002' || window.location.port === '3005';
  }

  if (currentAppEnvironment === APP_ENVS.PROD) {
    return false;
  }

  return false;
};
